import PropTypes from 'prop-types';
import SelectV2 from 'components/atoms/Select';
import { CreateLink } from 'components/molecules/user/MenuItem/styled';
import Typography from 'components/atoms/Typography';
import ChipsList from 'components/molecules/ChipsList';

import { getDayHourPerHalf, getErrorByKey } from 'utils';

import { ReactComponent as Delete } from 'assets/images/delete.svg';
import { Wrapper, SelectWrapper, SelectDivider, DeleteIcon } from './styled';

const TimeConfig = ({
  item,
  itemData = {},
  onSelect,
  name,
  createText = '+ Aggiungi orari',
  onClickCreate,
  onClickDelete,
  onSelectTime,
  errors,
}) => {
  const hours = getDayHourPerHalf();
  const selected = [];
  if (itemData?.day_off === false) {
    selected.push(item.id);
  }

  const showFirstInputs =
    itemData?.day_off === false &&
    !!(itemData.hasOwnProperty('first_from') && itemData.first_from !== null) &&
    !!(itemData.hasOwnProperty('first_to') && itemData.first_to !== null);
  const showSecondInputs =
    itemData?.day_off === false &&
    !!(
      itemData.hasOwnProperty('second_from') && itemData.second_from !== null
    ) &&
    !!(itemData.hasOwnProperty('second_to') && itemData.second_to !== null);

  return (
    <Wrapper>
      <ChipsList
        list={[item]}
        onClick={onSelect}
        selectedList={selected}
        onlyNative={true}
        name={name}
        error={errors?.base}
      />
      <div style={{ marginTop: 20 }}>
        {showFirstInputs && (
          <SelectWrapper>
            <SelectV2
              desktopMb={0}
              mb={0}
              fullWidth={true}
              label='Inizio'
              onChange={onSelectTime}
              name={`first_from-${item.id}`}
              items={hours}
              selectedKey={itemData?.first_from}
              error={errors?.first_from}
            />
            <SelectDivider>—</SelectDivider>
            <SelectV2
              desktopMb={0}
              mb={0}
              fullWidth={true}
              label='Fine'
              onChange={onSelectTime}
              name={`first_to-${item.id}`}
              items={hours}
              selectedKey={itemData?.first_to}
              error={errors?.first_to}
            />
            <DeleteIcon
              role='presentation'
              onClick={() => onClickDelete({ id: item.id, key: 'first' })}
            >
              <Delete />
            </DeleteIcon>
          </SelectWrapper>
        )}
        {showSecondInputs && (
          <SelectWrapper>
            <SelectV2
              desktopMb={0}
              mb={0}
              fullWidth={true}
              label='Inizio'
              onChange={onSelectTime}
              name={`second_from-${item.id}`}
              items={hours}
              selectedKey={itemData?.second_from}
            />
            <SelectDivider>—</SelectDivider>
            <SelectV2
              desktopMb={0}
              mb={0}
              fullWidth={true}
              label='Fine'
              onChange={onSelectTime}
              name={`second_to-${item.id}`}
              items={hours}
              selectedKey={itemData?.second_to}
            />
            <DeleteIcon
              role='presentation'
              onClick={() => onClickDelete({ id: item.id, key: 'second' })}
            >
              <Delete />
            </DeleteIcon>
          </SelectWrapper>
        )}
      </div>
      {!itemData?.day_off ? (
        <>
          {!showSecondInputs && (
            <CreateLink
              style={{ padding: 0, textAlign: 'left', display: 'block' }}
              as='span'
              role='presentation'
              onClick={() =>
                onClickCreate({
                  id: item.id,
                  key: !showFirstInputs ? 'first' : 'second',
                })
              }
            >
              {createText}
            </CreateLink>
          )}
        </>
      ) : (
        <Typography>Chiuso tutto il giorno.</Typography>
      )}
    </Wrapper>
  );
};

TimeConfig.propTypes = {
  item: PropTypes.shape({}),
  selected: PropTypes.any,
  onSelect: PropTypes.func.isRequired,
  name: PropTypes.string,
  onClickDelete: PropTypes.func.isRequired,
  onSelectTime: PropTypes.func.isRequired,
  onClickCreate: PropTypes.func.isRequired,
  errors: PropTypes.any,
};

export default TimeConfig;
